export default "__VITE_ASSET__676401c4__"